fragment MapAuthServiceTokenFragment on ServiceTokenResponse {
  ExpiresAt
  Tokens {
    Code
    Token
    ExpiresAt
    ServerUrl
    AuthType
    IsSSL
  }
}